export const isUnlimitedSize = (size) => {
    return size === 0;
};
